import { Component, OnInit } from '@angular/core';
export class ChartsComponent implements OnInit {

  options: Highcharts.Options;
  line: Highcharts.LineChart = {};
  chart: Highcharts.ChartOptions = {};
  axis: Array<Highcharts.AxisOptions> = [{}, {}];
  serieOptions: Array<Highcharts.SeriesOptions> = [{}, {}];
constructor() { }
/**
 * @return {?}
 */
ngOnInit() { }
/**
 * @return {?}
 */
teste() {
    console.log('framework on');
  }
/**
 * @param {?} x
 * @param {?} y
 * @return {?}
 */
sum(x, y) {
    return x + y;
  }
/**
 * @return {?}
 */
getTime() {
    const /** @type {?} */ hoje = new Date().toDateString();
    return console.log('Data retornada' + hoje);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-charts',
  template: `
    <div #container class="chart"></div>
  `,
  styles: [`

  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ChartsComponent_tsickle_Closure_declarations() {
/** @type {?} */
ChartsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ChartsComponent.ctorParameters;
/** @type {?} */
ChartsComponent.prototype.options;
/** @type {?} */
ChartsComponent.prototype.line;
/** @type {?} */
ChartsComponent.prototype.chart;
/** @type {?} */
ChartsComponent.prototype.axis;
/** @type {?} */
ChartsComponent.prototype.serieOptions;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
